import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Paginator from "../../../sub/Paginator";
import Util from "../../../../util/Util";
import DateUtil from "../../../../util/DateUtil";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../../sub/Icon";
import TableToolbar from "../../../sub/bootstrap/TableToolbar";
import GroupsUserAddModal from "./GroupsUserAddModal";

class GroupsListingUsersModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      nameFilter: "",
    };
    this.paginator = new Paginator(this);
  }

  resetSearchFields() {
    this.setState({
      nameFilter: "",
    });
  }

  areResultsFiltered = () => {
    return !Util.emptyString(this.state.nameFilter);
  };

  openUsersAddModal(user) {
    this.setState({
      modal: (
        <GroupsUserAddModal
          group={this.props.group}
          user={user}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  render() {
    let resetSearchButton = () => {
      let button = (
        <React.Fragment>
          <button className="btn btn-outline-secondary ml-3 mr-auto" disabled>
            <Icon icon="filter" />
          </button>
        </React.Fragment>
      );
      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <React.Fragment>
            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>
                  {<FormattedMessage id="Remove.Filter" />}
                </Tooltip>
              )}
              placement="bottom"
            >
              <Button
                variant="warning"
                className="ml-3 mr-auto"
                onClick={() => this.resetSearchFields()}
              >
                <Icon icon="filter" />
              </Button>
            </OverlayTrigger>
          </React.Fragment>
        );
      } else {
        return button;
      }
    };

    const users = Object.values(this.props.user).filter(
      (items) => items.group_id === this.props.group._id,
    );

    this.paginator.init(users.length);

    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    const usersNode =
      users.length > 0 &&
      users.map((user) => {
        if (this.state.nameFilter && this.state.nameFilter !== "") {
          if (
            user.name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1 &&
            user.first_name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (!this.paginator.keep()) return null;

        return (
          <tr className="d-flex" key={user._id}>
            <td className="col-4">
              {Util.formatFullName(user.first_name, user.name)}
            </td>
            <td className="col-3">
              {user.createdAt !== undefined && DateUtil.toDate(user.createdAt)}
            </td>
            <td className="col-3">
              {user.updatedAt !== undefined && DateUtil.toDate(user.updatedAt)}
            </td>
            <td className="col-2 text-center">
              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>{<FormattedMessage id="Edit" />}</Tooltip>
                )}
                placement="top"
              >
                <Button
                  variant={"info"}
                  onClick={(e) => this.openUsersAddModal(user)}
                >
                  <Icon icon="pen-to-square" />
                </Button>
              </OverlayTrigger>
            </td>
          </tr>
        );
      });

    return (
      <React.Fragment>
        <Modal
          show={true}
          size="xl"
          onHide={() => this.props.close()}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage id="Users" /> {this.props.group.name}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <TableToolbar>
              <input
                id="search_name"
                className="form-control form-control-sm"
                onChange={(e) => this.setState({ nameFilter: e.target.value })}
                placeholder={
                  this.props.intl.formatMessage({
                    id: "Name",
                  }) +
                  " " +
                  this.props.intl.formatMessage({
                    id: "Or",
                  }) +
                  " " +
                  this.props.intl.formatMessage({
                    id: "First.Name",
                  })
                }
                value={this.state.nameFilter}
                disabled={disableFormInput}
              />
              {resetSearchButton()}
              <Button
                variant="info"
                className="ml-auto"
                onClick={(e) => this.openUsersAddModal()}
              >
                <FormattedMessage id="User.Add" />
              </Button>
            </TableToolbar>

            <table className="table tablee4mad">
              <thead>
                <tr className="d-flex">
                  <th className="col-4">
                    <FormattedMessage id="Name" />
                  </th>
                  <th className="col-3">
                    <FormattedMessage id="Creation.Date" />
                  </th>
                  <th className="col-3">
                    <FormattedMessage id="Last.Update" />
                  </th>
                  <th className="col-2 text-center">
                    <FormattedMessage id="Actions" />
                  </th>
                </tr>
              </thead>

              <tbody>{usersNode}</tbody>
            </table>
            {this.paginator.render()}
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="info"
              onClick={() => this.props.close()}
            >
              <FormattedMessage id="Close" />
            </Button>
          </Modal.Footer>
        </Modal>

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GroupsListingUsersModal));
